<!--
 * @Description: 登陆失败
 * @Author: cooky
 * @Date: 2021-02-26 17:53:22
 * @LastEditors: cooky
 * @LastEditTime: 2021-05-11 14:31:33
-->
<template>
  <BasePop :title="$t('login_fail')">
    <div class="tip-fail">
      抱歉，未查询到此#第三方#账号下绑定的任何角色信息，请前往游戏内绑定后再尝试登录!
    </div>
    <div class="btn-group">
      <s-button style="">{{ $t('binding_ok') }}</s-button>
      <s-button type="gray">{{ $t('logout') }}</s-button>
    </div>
  </BasePop>
</template>
<script>
import { getServerAndRole, setCurrentRole } from '@/api'
import { mapState, mapMutations } from 'vuex'
import BasePop from './base'
// import router from '@/router'
// import Vue from 'vue'
// import i18n from '@/i18n'

export default {
  name: 'InfoLoginFail',
  // async beforeRouteEnter (to, from, next) {
  //   const { code, data } = await getServerAndRole()
  //   if (code === 0) {
  //     if (data.server_list && data.server_list.length > 0) {
  //       next(vm => {
  //         vm.servers = data.server_list
  //         vm.server = data.server_list[0] && data.server_list[0].server_name
  //         vm.roles = [{
  //           id: data.server_list[0] && data.server_list[0].id,
  //           name: data.server_list[0] && data.server_list[0].nickname
  //         }]
  //         vm.roleName = data.server_list[0] && data.server_list[0].nickname
  //         vm.role = data.server_list[0] && data.server_list[0].id
  //         vm.appId = data.server_list[0] && data.server_list[0].logical_region_id
  //       })
  //     } else {
  //       Vue.prototype.$info({
  //         content: () => {
  //           return new Vue({ i18n }).$t('please_bind_role_info')
  //         },
  //         okText: new Vue({ i18n }).$t('ok')
  //       })
  //       router.push({ name: 'ThirdPartInfoBinding' })
  //     }
  //   }
  // },
  components: {
    BasePop
  },
  data () {
    return {
      server: 17,
      servers: [],
      role: 17,
      roleName: '',
      roles: [],
      modal: null,
      loading: false,
      appId: 0
    }
  },
  computed: {
    ...mapState([
      'token',
      'lang'
    ])
  },
  watch: {
    lang () {
      this.init()
    }
  },
  methods: {
    ...mapMutations([
      'SET_TOKEN',
      'SET_SERVER_NAME',
      'SET_ROLE_NAME',
      'SET_APP_ID'
    ]),
    closeModal () {
      this.modal.close()
    },
    validateAndInit () {
      // if (!this.token) {
      //   this.modal = this.$modal({
      //     content: () => {
      //       return (
      //         <div class="tip">
      //           <div class="text">
      //             {this.$t('noLogin')}
      //           </div>
      //           <div class="ok-btn" onClick={this.toLogin.bind(this)}>
      //             {this.$t('ok')}
      //           </div>
      //         </div>
      //       )
      //     }
      //   })
      // } else {
      this.init()
      // }
    },
    async init () {
      const { code, data } = await getServerAndRole()
      if (code === 0) {
        if (data.server_list && data.server_list.length > 0) {
          this.servers = data.server_list
          this.server = data.server_list[0] && data.server_list[0].server_name
          this.roles = [{
            id: data.server_list[0] && data.server_list[0].id,
            name: data.server_list[0] && data.server_list[0].nickname
          }]
          console.log(data.server_list[0] && data.server_list[0].nickname)
          this.roleName = data.server_list[0] && data.server_list[0].nickname
          this.role = data.server_list[0] && data.server_list[0].id
          this.appId = data.server_list[0] && data.server_list[0].logical_region_id
        } else {
          this.$info({
            content: () => {
              return this.$t('please_bind_role_info')
            },
            okText: this.$t('ok')
          })
          this.$router.push({ name: 'ThirdPartInfoBinding' })
        }
      }
    },
    toLogin () {
      this.$router.push({ name: 'NineLogin' })
      this.modal.close()
    },
    changeServer (serverName) {
      const serverItem = this.servers.find(item => item.server_name === serverName)
      if (serverItem) {
        this.roles = [{
          id: serverItem.id,
          name: serverItem.nickname
        }]
        this.roleName = serverItem.nickname
        this.role = serverItem.id
        this.appId = serverItem.logical_region_id
      }
    },
    async selectRole () {
      this.loading = true
      const { code, data } = await setCurrentRole({
        id: this.role
      })
      if (code === 0) {
        const token = data.token
        this.SET_TOKEN(token)
        this.SET_SERVER_NAME(this.server)
        if (this.roleName) {
          this.SET_ROLE_NAME(this.roleName)
        }
        this.SET_APP_ID(this.appId)
      } else {
        // this.$info({
        //   content: () => {
        //     return info + ', ' + code
        //   },
        //   okText: this.$t('ok')
        // })
      }
      this.loading = false
    }
  }
}
</script>
<style lang="less" scoped>
  .btn-group {
    display: flex;
    justify-content: space-between;
  }
  .tip-fail {
    width: 100%;
    border: 1px solid #8d5a5a;
    font-size: 16px;
    color: #494949;
    padding: 15px;
    margin:45px 0 70px;
    background-color: #fff;
    line-height: 28px;
  }
  @media screen and (max-width: 750px) {
  }
</style>
